import routes from "./router";
import modules from "./store";
import i18nMessage from "./i18n";

export default {
  routes,
  modules,
  i18nMessage,
  selfComponents: {},
  config: {
    microApps: ["staff-app-k-one-frontend", "staff-app-k-one-tbr"]
  }
};
